import * as v from "valibot";

import { rpcContract } from "../rpc";

export const deleteUnifiedLinkRpcContract = rpcContract({
  name: "deleteUnifiedLink",
  paramsSchema: v.object({
    linkId: v.string(),
  }),
  resultSchema: v.object({
    linkId: v.string(),
  }),
});

export type DeleteUnifiedLinkParams = v.InferOutput<(typeof deleteUnifiedLinkRpcContract)["paramsSchema"]>;
export type DeleteUnifiedLinkResult = v.InferOutput<(typeof deleteUnifiedLinkRpcContract)["resultSchema"]>;
